export default "__VITE_ASSET__DrNTcNZV__"